import script from "./FilmSlideShow.vue?vue&type=script&setup=true&lang=js"
export * from "./FilmSlideShow.vue?vue&type=script&setup=true&lang=js"

import "./FilmSlideShow.vue?vue&type=style&index=0&id=1c9392ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9392ba"]])

export default __exports__